import { render, staticRenderFns } from "./viewTravel.vue?vue&type=template&id=a2d71196&scoped=true&"
import script from "./viewTravel.vue?vue&type=script&lang=js&"
export * from "./viewTravel.vue?vue&type=script&lang=js&"
import style0 from "./viewTravel.vue?vue&type=style&index=0&id=a2d71196&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d71196",
  null
  
)

export default component.exports